module.exports = __webpack_public_path__ + "media/images/course/aula_01-f108200c16c21de485977afb5467bd16.png";